var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCcMasterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "18px",
    viewBox: "0 0 29 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mastercard-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "D---00---Credit-card-payment-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-914.000000, -392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(712.000000, 291.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mastercard-logo",
    transform: "translate(202.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Combined-Shape",
    fill: "#FF5E00",
    cx: 8.7,
    cy: 8.57593842,
    rx: 8.7,
    ry: 8.57593842
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3432432,2.04867664 C12.4726303,3.62166184 11.2864865,5.96225604 11.2864865,8.57593842 C11.2864865,11.1896208 12.4726303,13.530215 14.3432432,15.1032002 C12.8240425,16.3806854 10.8533848,17.1518768 8.7,17.1518768 C3.89512268,17.1518768 0,13.3122984 0,8.57593842 C0,3.83957841 3.89512268,0 8.7,0 C10.8533848,0 12.8240425,0.771191469 14.3432432,2.04867664 Z",
    id: "Combined-Shape",
    fill: "#EE0006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1081081,15.1032002 C15.978721,13.530215 17.1648649,11.1896208 17.1648649,8.57593842 C17.1648649,5.96225604 15.978721,3.62166184 14.1081081,2.04867664 C15.6273089,0.771191469 17.5979666,0 19.7513514,0 C24.5562287,0 28.4513514,3.83957841 28.4513514,8.57593842 C28.4513514,13.3122984 24.5562287,17.1518768 19.7513514,17.1518768 C17.5979666,17.1518768 15.6273089,16.3806854 14.1081081,15.1032002 Z",
    id: "Combined-Shape",
    fill: "#FA9E00"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcMasterLogo);
export default __webpack_public_path__ + "static/media/cc-master-logo.0fced2f492f163434103b9c040995d7c.svg";
export { ForwardRef as ReactComponent };